import Cookies from 'js-cookie';

export function useCSRFToken(): string | undefined {
    // Django renders its own CSRF_COOKIE_NAME into site-settings (see
    // old_base.html), so the two cannot drift apart.
    const settings = document.getElementById('site-settings')?.textContent;

    const cookieName: string =
        (settings && JSON.parse(settings).csrfCookieName) ?? '_auth_csrftoken';

    const cookie = Cookies.get(cookieName);

    return cookie;
}
